import axios from 'axios';

// 基础配置（保持与其它 API 工具一致）
// 使用相对路径，通过Nginx代理访问后端API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const API_PREFIX = '/api/v1/facial-expression';

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL + API_PREFIX,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 请求拦截器 - 添加认证token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 添加用户ID到请求头
    const user = localStorage.getItem('user');
    if (user) {
      try {
        const userData = JSON.parse(user);
        if (userData.id) {
          config.headers['X-User-Id'] = userData.id.toString();
        }
      } catch (e) {
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // 处理401认证错误
    if (error.response?.status === 401) {
      const { handleAxiosAuthError } = await import('../utils/authErrorHandler');
      return handleAxiosAuthError(error);
    }
    return Promise.reject(error);
  }
);

export const ExpressionAnalysisAPI = {
  /**
   * 检查面部表情分析功能是否启用
   * @returns {Promise<{ enabled: boolean, message: string }>} 功能状态
   */
  checkStatus: async () => {
    try {
      const response = await api.get('/status');
      return response.data;
    } catch (error) {
      // 如果请求失败，默认返回禁用状态
      console.warn('检查面部表情分析功能状态失败:', error);
      return { enabled: false, message: '无法检查功能状态' };
    }
  },

  /**
   * 发送 base64 编码的图像帧到后端进行情绪分析
   * @param {string} base64Image - 去掉 dataURL 前缀的 base64 字符串
   * @returns {Promise<{ emotions: { name: string, percent: number }[] }>} 后端返回 top4 情绪概率
   */
  analyze: async (base64Image) => {
    const response = await api.post('/analyze', { image: base64Image });
    return response.data;
  },
};
